export default "__VITE_ASSET__UqgFQFx6__"